import React from 'react';

interface IconProps {
  className?: string;
  width?: number;
  height?: number;
}

export const ZapIcon: React.FC<IconProps> = ({ className = 'w-6 h-6', width = 24, height = 24 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);
